import styled from "styled-components"

import {StepWrapperType, StepType, ActiveBarType} from "../types"
import padding from "@irati/ui/src/global/padding"
import media from "@irati/ui/src/global/media"

const mobileStepSize = 10

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${({isMobile}: StepWrapperType) =>
    isMobile &&
    `
    justify-content: space-between;
    width: 100%;
  `};
  align-items: center;
`

export const StepsRecap = styled.div`
  margin-right: ${padding.tiny};
`

export const Steps = styled.div`
  position: relative;
  border-radius: 12px;
  background-color: ${({theme}) => theme.colors.greys.lightest};
  z-index: 10;
`

export const Step = styled.div<StepType>`
  padding: 2px;
  position: relative;
  display: inline-block;
  width: 25px;
  height: 25px;
  margin-left: 20px;
  z-index: 20;
  text-align: center;
  color: ${({active, theme}) => (active ? theme.colors.greys.white : "")};
  transition: color 0.2s;

  ${media.tablet`
    margin-left: ${mobileStepSize}px;
  `}
  &:nth-child(2) {
    margin-left: 0;
  }
`

export const ActiveBar = styled.div`
  position: absolute;
  height: 25px;
  border-radius: 12px;
  z-index: 15;
  width: ${({active}: ActiveBarType) => active * 25 + 20 * (active - 1)}px;
  background-color: ${({theme}) => theme.colors.perkbox.blue};
  -webkit-transition: width 0.2s;
  transition: width 0.2s;
  ${media.tablet`
    width: ${({active}: ActiveBarType) => active * 25 + mobileStepSize * (active - 1)}px;
  `}
`
